var Validator = require('validatorjs')
Validator.useLang('ja')

export default {
  name: 'login',
  data () {
    return {
      loginParam: {
        email: '',
        password: '',
        emailError: '',
        passwordError: '',
        isPush: false
      },
      forgotParam: {
        email: '',
        code: '',
        newPassword: '',
        emailError: '',
        passwordError: '',
        codeError: '',
        isPush: false
      },
      firstLoginParam: {
        email: '',
        oldPassword: '',
        newPassword: '',
        emailError: '',
        oldError: '',
        newError: '',
        isPush: false
      },
      tab: '1',
      isConfirm: false,
      isSuccess: false,
      message: '',
      isAlert: false,
      error: {},
      validation: {
        username: false,
        password: false
      },
      isActivate: false
    }
  },
  methods: {
    login (evt) {
      evt.preventDefault()

      this.loginParam.isPush = true

      let v = new Validator({
        'メールアドレス': this.loginParam.email,
        'パスワード': this.loginParam.password
      }, {
        'メールアドレス': 'required|email',
        'パスワード': 'required|min:8'
      })

      let pass = v.passes()

      this.loginParam.emailError = v.errors.first('メールアドレス')
      this.loginParam.passwordError = v.errors.first('パスワード')

      if (!pass) {
        this.loginParam.isPush = false
      } else {
        this.$cognito.login(this.loginParam.email, this.loginParam.password)
          .then(credentials => {
            this.$store.commit('onAuthStateChanged', credentials.data.Credentials)
            this.$store.commit('onUserStateChanged', {
              enterpriseId: credentials.data.IdentityId.replace('ap-northeast-1:', ''),
              email: this.loginParam.email
            })
            this.$store.commit('onLoginStatusChanged', true)
            this.$router.push(this.$route.query.redirect || '/dashboard')
          })
          .catch(err => {
            this.isAlert = true
            this.error = err
            this.loginParam.password = ''
            this.loginParam.isPush = false
          })
      }
    },
    forgotPassword (evt) {
      evt.preventDefault()
      this.forgotParam.isPush = true

      if (!this.isConfirm) {
        let v = new Validator({
          'メールアドレス': this.forgotParam.email
        }, {
          'メールアドレス': 'required|email'
        })

        let pass = v.passes()

        this.forgotParam.emailError = v.errors.first('メールアドレス')

        if (!pass) {
          this.forgotParam.isPush = false
        } else {
          this.$cognito.forgotPassword(this.forgotParam.email)
            .then(result => {
              this.isConfirm = true
              this.isSuccess = true
              this.message = '登録メールアドレスに検証コードを送信しました'
              this.forgotParam.isPush = false
            })
            .catch(err => {
              this.isAlert = true
              this.error = err
              this.forgotParam.email = ''
              this.forgotParam.isPush = false
            })
        }
      } else {
        let v = new Validator({
          'メールアドレス': this.forgotParam.email,
          '検証コード': this.forgotParam.code,
          '新しいパスワード': this.forgotParam.newPassword
        }, {
          'メールアドレス': 'required|email',
          '検証コード': 'required|size:6',
          '新しいパスワード': 'required|min:8'
        })

        let pass = v.passes()

        this.forgotParam.emailError = v.errors.first('メールアドレス')
        this.forgotParam.codeError = v.errors.first('検証コード')
        this.forgotParam.passwordError = v.errors.first('新しいパスワード')

        if (!pass) {
          this.forgotParam.isPush = false
        } else {
          this.$cognito.confirmPassword(this.forgotParam.email, this.forgotParam.code, this.forgotParam.newPassword)
            .then(result => {
              this.isSuccess = true
              this.message = 'パスワードを変更しました'
              this.loginParam.email = this.forgotParam.email
              this.forgotParam = {}
              this.tab = '1'
              this.forgotParam.isPush = false
            })
            .catch(err => {
              this.isAlert = true
              this.error = err
              this.forgotParam.code = ''
              this.forgotParam.newPassword = ''
              this.forgotParam.isPush = false
            })
        }
      }
    },
    completeNewPasswordChallenge (evt) {
      evt.preventDefault()

      this.firstLoginParam.isPush = true

      let v = new Validator({
        'メールアドレス': this.firstLoginParam.email,
        '仮パスワード': this.firstLoginParam.oldPassword,
        '新しいパスワード': this.firstLoginParam.newPassword
      }, {
        'メールアドレス': 'required|email',
        '仮パスワード': 'required|min:8',
        '新しいパスワード': 'required|min:8'
      })

      let pass = v.passes()

      this.firstLoginParam.emailError = v.errors.first('メールアドレス')
      this.firstLoginParam.oldError = v.errors.first('仮パスワード')
      this.firstLoginParam.newError = v.errors.first('新しいパスワード')

      if (!pass) {
        this.firstLoginParam.isPush = false
      } else {
        this.$cognito.completeNewPasswordChallenge(this.firstLoginParam.email, this.firstLoginParam.oldPassword, this.firstLoginParam.newPassword)
          .then(result => {
            this.isSuccess = true
            this.message = 'パスワードを変更しました'
            this.loginParam.email = this.firstLoginParam.email
            this.firstLoginParam = {}
            this.tab = '1'
            this.firstLoginParam.isPush = false
          })
          .catch(err => {
            this.isAlert = true
            this.error = err
            this.firstLoginParam.oldPassword = ''
            this.firstLoginParam.newPassword = ''
            this.firstLoginParam.isPush = false
          })
      }
    }
  },
  mounted () {
    if (this.$route.query.activate) {
      this.isActivate = true
      this.error.message = 'メールアドレスを認証しました。ログインして企業情報の登録にお進みください。'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/login/login.js